import RoleAccess from "@/components/billing_mapping/role_access/Index";
import RoleAccessRoute from "@/components/billing_mapping/role_access/routes";

let BillingMappingRoute = [
  {
    path: "role-access",
    meta: {
      title: "Role Access",
    },
    children: RoleAccessRoute,
    component: RoleAccess,
  },
];

export default BillingMappingRoute;
